import fullstack from '../asset/back.jpg';
import difference from '../asset/back1.jpg';
import front from '../asset/front.jpg';
import back from '../asset/lab.jpg';

const ImgFile = {
  fullstack,
  difference,
  front,
  back,
};
export default ImgFile;
